const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfCivilization extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfCivilization,
            "Immediately, each civilization may either: increase its population; or build a farm, mine, or urban building; or develop a technology. It costs 1 food, 1 resource, or 1 science less than usual.",
            {}
        )
    }
}

module.exports = DevelopmentOfCivilization;